<template>
    <div>
        <router-link class="media" :class="[message.status, { 'selected': selected }]" :to="{ name: 'messages.inbox.view', params: { id: message.message_id} }" v-tooltip:right="message.subject">
            <div class="avatar">
                <img :src="message.customer_details.avatar" class="rounded-circle" alt="">
            </div>
            <div class="media-body mg-l-15">
                <div class="tx-color-03 d-flex align-items-center justify-content-between mg-b-2">
                    <span class="tx-12">{{ message.customer_details.name }}</span>
                    <span class="tx-11">{{ message.created_at|toDate('LT') }}</span>
                </div>
                <h6 class="tx-13">{{ message.topic }}</h6>
                <p class="tx-12 tx-color-03 mg-b-0">{{ message.message|truncate(160) }}</p>
            </div>
        </router-link>
    </div>
</template>

<script>
	export default {
		computed: {
			selected() {
				return this.$route.params.id === this.message.message_id;
			}
		},
		props: ["message"]
	};
</script>